// Mock data for Botlab Solutions landing page

export const companyInfo = {
  name: "Botlab Solutions FZ-LLC",
  legalType: "Free Zone Limited Liability Company (FZ-LLC)",
  authority: "Ras Al Khaimah Economic Zone (RAKEZ)",
  activity: "Software House – Computer systems and communication systems design",
  address: "Compass Building, Al Shohada Road, Al Hamra Industrial Zone-FZ, Ras Al Khaimah, United Arab Emirates",
  manager: "Fernando David Quero Ramirez",
  tagline: "Enterprise Software Solutions for the Digital Economy",
  description: "We build scalable, secure, and high-performance software platforms that power modern businesses. From player account management to transaction processing, we deliver technology that performs."
};

export const services = [
  {
    id: 1,
    title: "Software Platform Development",
    description: "Custom-built enterprise platforms designed for scalability, performance, and reliability. We architect solutions that grow with your business.",
    icon: "Code"
  },
  {
    id: 2,
    title: "PAM Systems",
    description: "Player Account Management systems with robust user authentication, profile management, and seamless integration capabilities.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Infrastructure & Servers",
    description: "Cloud and on-premise infrastructure solutions with high availability, disaster recovery, and optimized performance.",
    icon: "Server"
  },
  {
    id: 4,
    title: "API Integrations",
    description: "Seamless integration with third-party services, payment providers, and external platforms through secure, well-documented APIs.",
    icon: "Plug"
  },
  {
    id: 5,
    title: "Monitoring & Back-office",
    description: "Real-time monitoring dashboards, comprehensive reporting systems, and intuitive back-office management tools.",
    icon: "BarChart3"
  },
  {
    id: 6,
    title: "Technical Support",
    description: "24/7 technical support and maintenance services to ensure your platforms run smoothly around the clock.",
    icon: "Headphones"
  }
];

export const solutions = [
  {
    id: 1,
    title: "Scalable Platforms",
    description: "Built to handle millions of transactions and users without compromising performance.",
    icon: "TrendingUp"
  },
  {
    id: 2,
    title: "High-Availability Systems",
    description: "99.99% uptime guarantee with redundant architecture and automatic failover.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Secure Architectures",
    description: "Enterprise-grade security with encryption, access controls, and compliance frameworks.",
    icon: "Lock"
  },
  {
    id: 4,
    title: "Transaction Processing",
    description: "High-throughput transaction systems with real-time processing and complete audit trails.",
    icon: "Wallet"
  }
];

export const compliancePoints = [
  "Strictly B2B technology provider",
  "Does not operate any gambling platforms",
  "Does not accept or handle end-user funds",
  "Licensed Free Zone company under RAKEZ",
  "Full regulatory compliance"
];

export const countries = [
  "United Arab Emirates",
  "United States",
  "United Kingdom",
  "Germany",
  "France",
  "Spain",
  "Italy",
  "Netherlands",
  "Switzerland",
  "Singapore",
  "Hong Kong",
  "Japan",
  "Australia",
  "Canada",
  "Brazil",
  "Mexico",
  "India",
  "South Africa",
  "Other"
];

export const seoData = {
  title: "Botlab Solutions | Enterprise Software & Platform Development | UAE",
  description: "Botlab Solutions FZ-LLC is a UAE-based technology company specializing in enterprise software development, PAM systems, and scalable platform infrastructure. B2B technology solutions for modern businesses.",
  keywords: "enterprise software, platform development, PAM systems, player account management, UAE software company, RAKEZ, B2B technology, API integration, infrastructure solutions"
};
